import styled from "@emotion/styled";

export const LandingFooter = styled.footer`
width:100%;
height:fit-content;
padding:10px 10px;
background-color: #03406c;
color:white;
display:flex;
flex-direction:column;
align-items:center;
justify-content:space-between;
font-size: clamp(14px, 2vw, 18px);
`